import { render } from "./BasicUsage.vue?vue&type=template&id=36c77f52&ts=true"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"

import "./BasicUsage.vue?vue&type=style&index=0&id=36c77f52&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__